import React from 'react'
import { useRef } from 'react'
import emailjs from '@emailjs/browser';
import NavBar from './NavBar';
import Footer from './Footer';
import './contactus.css'
import { Row, Col } from 'react-bootstrap';

import { Form, Button } from 'react-bootstrap'

const ContactUs = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_ua3qsgw', 'template_jdzycvb', form.current, '3tQjJpWyRKxL88mEm')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });

    }
    return (
        <>
            <NavBar />
            <Row className='contact-comp'>
                <Col md={4} lg={4} sm={10} className='email-form'>
                    <h2>For all inquiries, please send us an email to <small>squadrastandupteam@gmail.com</small> or directly fill the form below.</h2>
                    <Form ref={form} onSubmit={sendEmail} >
                        <Form.Control name='name' type='text' placeholder='Full Name'  required/>
                        <Form.Control name='email' type='email' placeholder='Email' required/>
                        <Form.Control name='subject' type='text' placeholder='Subject'  required/>
                        <Form.Control as="textarea" name='message' placeholder='Message' required/>
                        <Button className='submit-form' type='submit'>Send Email</Button>
                    </Form>
                </Col>

                <Col md={4} lg={4}
                sm={0}>
                    <img  className='send-img' src="/images/Mention-bro.png" alt="" />
                </Col>

            </Row>
            <Footer />
        </>
    )

}


export default ContactUs;